import { options } from '@engine/features/apply_chosen';

$.fn.stateSelect = function () {
  return this.each(function () {
    var prefix = $(this).attr('id').split('_').slice(0, -1).join('_');
    var inputField = $('#' + prefix + '_state');
    var fieldSelector = inputField.attr('id');
    var fieldName = inputField.attr('name');
    $(this).on('change', function () {
      var selectedCountry = $(this).val();
      var stateSelect = $('select#states-' + selectedCountry)[0];
      $('#' + fieldSelector + '_chosen').remove();

      if (typeof stateSelect !== 'undefined') {
        $('.states.' + prefix + '_states').show();
        var $clone = $(stateSelect).clone();
        $clone.attr({
          id: fieldSelector,
          name: fieldName,
          "class": 'for_chosen'
        });
        $('#' + fieldSelector).replaceWith($clone.val(inputField.val()));
        $('#' + fieldSelector).chosen(options);
      } else if (stateSelect) {
        $('.states.' + prefix + '_states').hide();
        $('#' + fieldSelector).remove();
        $('.' + fieldSelector).append(inputField);
      }
    });
    $(this).trigger('change');
  });
};